import React, { useState, useEffect } from "react";
import PiiReportFacilitiesDisplay from "../../components/PIIReportFacilities/PIIReportFacilitiesDisplay";
import PropTypes from "prop-types";
import { checkPermission } from "services/sharedServices";
import { useParams } from "react-router-dom";
import { useAuth } from "context/AuthContext";

const PIIReportByFacilities = (props) => {
  const { roles, hasPermission, isLoaded } = useAuth();

  const [reportDisplay, setReportDisplay] = useState(false);
  const { ticketNumber } = useParams();

  useEffect(() => {
    if (!isLoaded) return;

    localStorage.setItem("OBTPII", window.location.pathname);

    if (roles.length === 0) {
      window.location.href = "/";
      return;
    }

    if (hasPermission("FACBRZ_Group")) {
      setReportDisplay(true);
    } else {
      setReportDisplay(false);
      window.localStorage.removeItem("OBTPII");
    }
  }, [roles, hasPermission, isLoaded]);

  return (
    <>
      {reportDisplay ? (
        <PiiReportFacilitiesDisplay facilitiesTicketNumber={ticketNumber} />
      ) : (
        <>Not eligible to access this page.</>
      )}
    </>
  );
};

PIIReportByFacilities.propTypes = {
  match: PropTypes.any,
};

export default PIIReportByFacilities;
